import * as React from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { black } from 'material-ui/styles/colors';
import { ProgramMemberInfo } from './members.types';
import { Schedule, Level } from '../programs/Types';
import { formatTime } from '../util/time-util';

const DEFAULT_LEVEL: Level = {id: -1, level: '', requiredAttendance: 0};

const fieldStyles = {
  rootStyle: {
    cursor: 'text'
  },
  textStyle: {
    color: black
  }
};

type Props = {
  readonly programMember: ProgramMemberInfo
  readonly programMemberDetailChangeHandler: Function
};

type States = {
  readonly programMember: ProgramMemberInfo
  readonly selectedScheduleIdsMap: any
};

class ProgramMemberDetailsComponent extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);

    this.state = {
      programMember: this.props.programMember,
      selectedScheduleIdsMap: this.getSelectedScheduleIdsMap(this.props.programMember)
    };

    this.onLevelSelect = this.onLevelSelect.bind(this);
    this.onScheduleCheck = this.onScheduleCheck.bind(this);
    this.getSelectedScheduleIdsMap = this.getSelectedScheduleIdsMap.bind(this);
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      programMember: nextProps.programMember,
      selectedScheduleIdsMap: this.getSelectedScheduleIdsMap(nextProps.programMember)
    });  
  }

  render() {
    let programMember = this.state.programMember;
    return (
      <div className="row ma2 no-gutters">
        <div className="col-12">
          <div className="input-group mb-2 mr-sm-2 mb-sm-0">
            <TextField
              fullWidth={true}
              floatingLabelText="Program Name"
              floatingLabelFixed={true}
              value={programMember.program.name}
              disabled={true}
              style={fieldStyles.rootStyle}
              inputStyle={fieldStyles.textStyle}
              floatingLabelStyle={fieldStyles.textStyle}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="input-group mb-2 mr-sm-2 mb-sm-0">
            <SelectField
              fullWidth={true}
              floatingLabelText="Level"
              value={programMember.level ? programMember.level.id : DEFAULT_LEVEL.id}
              onChange={this.onLevelSelect}
            >
              <MenuItem key={DEFAULT_LEVEL.id} value={DEFAULT_LEVEL.id} primaryText={DEFAULT_LEVEL.level} />
              {
                programMember.program.levels.map((level, index) => {
                  return <MenuItem key={index} value={level.id} primaryText={level.level} />;
                })
              }
            </SelectField>
          </div>
        </div>
        {
          programMember.program.schedules.map((schedule, index) => {
            const menuText = schedule.day + ' ' + formatTime(schedule.startHour, schedule.startMinute)
              + ' - ' + formatTime(schedule.endHour, schedule.endMinute);
            let scheduleId = (schedule.id) ? schedule.id : 0;
            return <div className="col-12 pt-3" key={index}>
                    <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                      <Checkbox
                        label={menuText}
                        checked={this.state.selectedScheduleIdsMap[scheduleId]}
                        value={scheduleId}
                        onCheck={this.onScheduleCheck}
                      />
                    </div>
                  </div>;
          })
        }
      </div>
    );
  }

  private onLevelSelect(event: React.TouchEvent<HTMLSelectElement>, index: number, value: number) {
    if (value !== DEFAULT_LEVEL.id) {
      let selectedLevels = this.state.programMember.program.levels.filter((level: Level) => {
        return level.id === value;
      });
  
      let newProgramMember = this.state.programMember;
      newProgramMember.level = selectedLevels[0];
  
      this.setState(
        {
          programMember: newProgramMember
        }, 
        () => {
          if (this.props.programMemberDetailChangeHandler) {
            this.props.programMemberDetailChangeHandler();
          }
        }
      );
    } else {
      this.setState({
        programMember: {
          ...this.state.programMember,
          level: DEFAULT_LEVEL
        }
      });
    }
  }

  private onScheduleCheck(event: React.MouseEvent<HTMLInputElement>, isInputChecked: boolean) {
    let newSelectedScheduleIdsMap = this.state.selectedScheduleIdsMap;
    newSelectedScheduleIdsMap[event.currentTarget.value] = isInputChecked;
    
    let newProgramMember = this.state.programMember;
    if (isInputChecked) {
      let filteredSchedules = this.state.programMember.program.schedules.filter((schedule: Schedule) => {
        let scheduleId = (schedule.id) ? schedule.id : 0;
        return scheduleId.toString() === event.currentTarget.value;
      });

      if (filteredSchedules.length > 0) {
        newProgramMember.schedules.push(filteredSchedules[0]);
      }
    } else {
      newProgramMember.schedules = this.state.programMember.schedules.filter((schedule: Schedule) => {
        let scheduleId = (schedule.id) ? schedule.id : 0;
        return scheduleId.toString() !== event.currentTarget.value;
      });
    }

    this.setState(
      {
        programMember: newProgramMember,
        selectedScheduleIdsMap: newSelectedScheduleIdsMap
      },
      () => {
        if (this.props.programMemberDetailChangeHandler) {
          this.props.programMemberDetailChangeHandler();
        }
      }
    );
  }

  private getSelectedScheduleIdsMap(programMember: ProgramMemberInfo) {
    let selectedScheduleIdsMap = {};
    let selectedScheduleIds = programMember.schedules.map(function(schedule) { return schedule.id; });

    for (let i = 0; i < programMember.program.schedules.length; i++) {
      let key = programMember.program.schedules[i].id;
      key = (key) ? key : 0;
      selectedScheduleIdsMap[key] = selectedScheduleIds.indexOf(key) !== -1;
    }

    return selectedScheduleIdsMap;
  }
}

export default ProgramMemberDetailsComponent;



// WEBPACK FOOTER //
// ./src/members/programMember.details.component.tsx